/**
 * isiXhosa: Bookings
 *
 * What this file covers: The Bookings menu: calendar, bookings, services, staff and hours, classes, booking
 * settings, calendar sync.
 *
 * Tone: Friendly and clear, for small business owners. Times and dates read the way the language says them.
 * Words the client sees (confirmations, reminders) sound polite and personal.
 *
 * isiXhosa: Everyday isiXhosa as used in South African business. Keys not translated yet fall back to English,
 * so a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const bookings: Catalog = {};

export default bookings;
